import { ref } from "vue";
import { accountKey, AccountIdentity } from "@/utils/accountSession";

export const DARK_THEME_PERMISSION = "UI_DARK_THEME";
export type Theme = "light" | "dark";
export interface ThemeIdentity extends AccountIdentity { permissions?: string[] }
export const currentTheme = ref<Theme>("light");

export function canUseDarkTheme(identity: ThemeIdentity | null | undefined): boolean {
  return Boolean(identity?.permissions?.includes(DARK_THEME_PERMISSION));
}
export function themeStorageKey(identity: ThemeIdentity | null | undefined): string | null {
  const account = accountKey(identity || null);
  return account ? `esign:theme:${account}` : null;
}
function apply(theme: Theme): void {
  currentTheme.value = theme;
  if (typeof document !== "undefined") {
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.style.setProperty("color-scheme", theme);
  }
}
export function syncTheme(identity: ThemeIdentity | null | undefined): void {
  const key = themeStorageKey(identity);
  let preference: string | null = null;
  try { if (key) preference = localStorage.getItem(key); } catch { /* Storage can be blocked. */ }
  apply(canUseDarkTheme(identity) && preference === "dark" ? "dark" : "light");
}
export function setTheme(identity: ThemeIdentity | null | undefined, theme: Theme): boolean {
  if (!canUseDarkTheme(identity)) { syncTheme(identity); return false; }
  const key = themeStorageKey(identity);
  if (!key || (theme !== "light" && theme !== "dark")) return false;
  try { localStorage.setItem(key, theme); } catch { /* Keep a usable session even without persistence. */ }
  apply(theme);
  return true;
}
